// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3WYFWSxAthNUjG0Ue0m0-L {\n    /* reset excess padding for last row */\n    padding-bottom: 8px;\n}\n\n.TjfKBz6oTTXU22PB6hPLJ {\n    margin-top: 27px;\n    border-top: 1px solid #C2CDD7;\n}\n\n._20zvzYOrDUPgaRVDQTwazn {\n    padding: 20px 0;\n    border-bottom: 1px solid #C2CDD7;\n    cursor: pointer;\n}\n\n._20zvzYOrDUPgaRVDQTwazn:last-child {\n    border-bottom: none;\n}\n\n._3ULxjpNlOo1jK1oWPW9sji {\n    margin-bottom: 7px;\n    color: #2eb6c8;\n}\n\n._3rCRYiCM0JIlts4O8pWhpQ {\n    color: #9D9D9D;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.X3bE--GDhEOi1U_iQMODy {\n    color: #9D9D9D;\n}\n\n.O_ziDYyJE9kzIctB4q-0H {\n    font-size: 16px;\n    margin: 100px 0;\n    text-align: center;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "_3WYFWSxAthNUjG0Ue0m0-L",
	"documents": "TjfKBz6oTTXU22PB6hPLJ",
	"documentRow": "_20zvzYOrDUPgaRVDQTwazn",
	"category": "_3ULxjpNlOo1jK1oWPW9sji",
	"properties": "_3rCRYiCM0JIlts4O8pWhpQ",
	"timestamp": "X3bE--GDhEOi1U_iQMODy",
	"empty": "O_ziDYyJE9kzIctB4q-0H"
};
module.exports = exports;
